/*
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2024 UNESP Universidade Estadual Paulista "Júlio de Mesquita Filho"
 * Copyright 2024-2026 UNICAMP Universidade Estadual de Campinas
 *
 */

import { ChangeDetectionStrategy, Component, OnInit, inject, signal } from '@angular/core'
import { ToastEvent } from '../../models/toast-event'
import { ToastService } from '../../services/toast.service'
import { ToastComponent } from '../toast/toast.component'

@Component({
  selector: 'app-toaster',
  templateUrl: './toaster.component.html',
  styleUrl: './toaster.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ToastComponent],
})
export class ToasterComponent implements OnInit {
  private toastService = inject(ToastService)

  readonly currentToasts = signal<ToastEvent[]>([])

  ngOnInit() {
    this.toastService.toastEvents.subscribe(toast => {
      this.currentToasts.update(prev => [...prev, { type: toast.type, title: toast.title, message: toast.message }])
    })
  }

  dispose(index: number) {
    this.currentToasts.update(prev => prev.filter((_, i) => i !== index))
  }
}
